// src/hooks/websocket/types.ts
export enum WebSocketStatus {
    CONNECTING = 0,
    OPEN = 1,
    CLOSING = 2,
    CLOSED = 3,
    RECONNECTING = 4,
  }
  
  export interface WebSocketState {
    status: WebSocketStatus;
    error: Error | null;
    reconnectAttempt: number;
    lastReconnectTime: number;
  }
  
  export interface WebSocketMessage {
    type: string;
    data: {
      accountId: string;
      filename: string;
      [key: string]: any;
    };
  }
  
  export interface WebSocketConfig {
    MAX_RECONNECT_ATTEMPTS: number;
    RECONNECT_DELAY: number;
    MIN_TIME_BETWEEN_RECONNECTS: number;
  }

  export interface WebSocketHandlers {
    onFileChange?: () => Promise<void>;
  }

  export enum Action {
    FILE_UPLOADED = 'FILE_UPLOADED',
    FILE_DELETED = 'FILE_DELETED',
    FILE_UPDATED = 'FILE_UPDATED'
  }